import { Link, useNavigate } from "react-router-dom";
import "./sidebar.css";

const SideBar = () => {
  const navigate = useNavigate();

  const handleLogout = (e) => {
    e.preventDefault();
    localStorage.removeItem("parentData");
    localStorage.removeItem("parentId");
    localStorage.removeItem("token");
    localStorage.removeItem("session");
    localStorage.removeItem("refreshToken");
    navigate("/parent-login");
  };

  const navItems = [
    {
      icon: "fas fa-home",
      text: "Dashboard",
      link: "/parent-dashboard",
    },
    {
      icon: "fas fa-list",
      text: "Modules Completed",
      link: "/parent-dashboard",
    },
    {
      icon: "fas fa-list",
      text: "Clif Assessment",
      link: "/parent-dashboard",
    },
    {
      icon: "fas fa-list",
      text: "Help Center",
      link: "/parent-dashboard",
    },
  ];

  return (
    <aside className="left-sidebar">
      <div className="sidebar-wrapper">
        {/* Logo Section */}
        <div className="brand-logo d-flex align-items-center p-2">
          <Link to="/parent-dashboard" className="logo-container  p-3">
            <img src="./images/logo.png" className="logo" alt="Logo-Dark" />
          </Link>
          <a href="#" className="sidebar-toggler d-xl-none ms-auto">
            <i className="fas fa-times"></i>
          </a>
        </div>

        {/* Navigation */}
        <nav className="sidebar-nav">
          <ul className="nav-list list-unstyled d-flex flex-column gap-1">
            {/* Map through regular nav items */}
            {navItems.map((item, index) => (
              <li className="nav-item" key={index}>
                <Link className="nav-link" to={item.link}>
                  <i className={`nav-icon ${item.icon}`}></i>
                  <span className="nav-text">{item.text}</span>
                </Link>
              </li>
            ))}

            {/* Special handling for logout */}
            <li className="nav-item">
              <a className="nav-link" href="#" onClick={handleLogout}>
                <i className="nav-icon fas fa-sign-out-alt"></i>
                <span className="nav-text">Logout</span>
              </a>
            </li>
          </ul>
        </nav>
      </div>
    </aside>
  );
};

export default SideBar;
